// extracted by mini-css-extract-plugin
export default {"replies":"tweet-replies_replies__QSvhV","link":"tweet-replies_link__n4rOe","text":"tweet-replies_text__66RN+"};